import { Modal, Button } from 'react-bootstrap';

const CookiesModal = ({ show, onHide }) => {
    return (
        <Modal show={show} onHide={onHide} size="lg" centered className="rounded-0">
            <Modal.Header closeButton className="border-0">
                <Modal.Title className="fw-bold text-uppercase" style={{ color: '#1b337e', fontSize: '1.2rem' }}>
                    Política de Cookies
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-4 pb-4" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <h6 className="fw-bold text-dark">¿Qué son las cookies?</h6>
                <p className="text-muted small">
                    Una cookie es un pequeño archivo de texto que se almacena en su navegador cuando visita casi cualquier página web. Su utilidad es que la web sea capaz de recordar su visita cuando vuelva a navegar por esa página.
                </p>

                <h6 className="fw-bold text-dark mt-4">Cookies utilizadas en este sitio</h6>
                <ul className="text-muted small">
                    <li><strong>Cookies Técnicas:</strong> Son necesarias para el funcionamiento de la web (como el inicio de sesión o la aceptación de este aviso).</li>
                    <li><strong>Cookies de Análisis:</strong> Nos permiten cuantificar el número de usuarios y realizar la medición y análisis estadístico de la utilización que hacen los usuarios de nuestra web (vía Google Analytics).</li>
                </ul>

                <h6 className="fw-bold text-dark mt-4">Cómo desactivar las cookies</h6>
                <p className="text-muted small">
                    Usted puede restringir, bloquear o borrar las cookies de este sitio utilizando la configuración de su navegador. En cada navegador la operativa es diferente, la función de 'Ayuda" le mostrará cómo hacerlo.
                </p>
            </Modal.Body>
            <Modal.Footer className="border-0">
                <Button
                    variant="dark"
                    onClick={onHide}
                    className="rounded-0 px-4 text-uppercase fw-bold"
                    style={{ fontSize: '12px' }}
                >
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CookiesModal;